/* tslint:disable */
/* eslint-disable */
/**
 * VisaCenter.Svc.WebApi
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import {
  DUMMY_BASE_URL,
  assertParamExists,
  setSearchParams,
  serializeDataIfNeeded,
  toPathString,
  createRequestFunction,
} from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, BaseAPI, operationServerMap } from './base';

interface AttachedFile {
  fileName?: string;
  savePath?: string;
}

/**
 *
 * @export
 * @interface BoardDetailSearchModel
 */
export interface BoardDetailSearchModel {
  /**
   * 일련번호
   * @type {number}
   * @memberof BoardDetailSearchModel
   */
  postId?: number;
  /**
   * 게시판 노출 id
   * @type {number}
   * @memberof BoardDetailSearchModel
   */
  seqNo?: number;
  /**
   * 게시판구분
   * @type {number}
   * @memberof BoardDetailSearchModel
   */
  boardNo?: number;
  /**
   * 작성자
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  regUserName?: string | null;
  /**
   * 제목
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  title?: string | null;
  /**
   * 내용
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  contents?: string | null;
  /**
   * 이메일
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  email?: string | null;
  /**
   * 파일 수
   * @type {Array<string>}
   * @memberof BoardDetailSearchModel
   */
  postAttachedFileCount?: number | null;
  /**
   * 파일 리스트
   * @type {Array<AttachedFile>}
   * @memberof BoardDetailSearchModel
   */
  postAttachedFileList?: Array<AttachedFile> | null;
  /**
   * 비밀설정여부
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  isPasswordSet?: string | null;
  /**
   * 답변여부
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  isAnswered?: string | null;
  /**
   * 등록일
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  regDate?: string;

  /**
   * 공지
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  isMustRead?: string;
  /**
   * 관리자답변
   * @type {string}
   * @memberof BoardDetailSearchModel
   */
  answer?: string | null;
}
/**
 *
 * @export
 * @interface BoardInsertModel
 */
export interface BoardInsertModel {
  /**
   * 결과 (S: 성공, F: 실패)
   * @type {string}
   * @memberof BoardInsertModel
   */
  result?: string | null;
  /**
   * 일련번호
   * @type {number}
   * @memberof BoardInsertModel
   */
  PostId?: number | null;
}
/**
 *
 * @export
 * @interface BoardInsertRequest
 */
export interface BoardInsertRequest {
  /**
   * 게시판구분
   * @type {number}
   * @memberof BoardInsertRequest
   */
  boardNo?: number | null;
  /**
   * 작성자
   * @type {string}
   * @memberof BoardInsertRequest
   */
  regUserName?: string | null;
  /**
   * 제목
   * @type {string}
   * @memberof BoardInsertRequest
   */
  title?: string | null;
  /**
   * 내용
   * @type {string}
   * @memberof BoardInsertRequest
   */
  contents?: string | null;
  /**
   * 이메일
   * @type {string}
   * @memberof BoardInsertRequest
   */
  email?: string | null;
  /**
   * 파일1
   * @type {Array<string>}
   * @memberof BoardInsertRequest
   */
  files?: Array<string> | null;
  /**
   * 비밀번호
   * @type {string}
   * @memberof BoardInsertRequest
   */
  password?: string | null;
  /**
   * 비밀번호 여부
   * @type {boolean}
   * @memberof BoardInsertRequest
   */
  isPasswordSet?: boolean | null;
}
/**
 *
 * @export
 * @interface BoardListSearchModel
 */
export interface BoardListSearchModel {
  /**
   * 전체게시글수
   * @type {number}
   * @memberof BoardListSearchModel
   */
  totalItemCount?: number | null;
  /**
   * 전체페이지수
   * @type {number}
   * @memberof BoardListSearchModel
   */
  totalPageCount?: number | null;
  /**
   * 게시글 리스트
   * @type {Array<BoardDetailSearchModel>}
   * @memberof BoardListSearchModel
   */
  items?: Array<BoardDetailSearchModel> | null;
}
/**
 *
 * @export
 * @interface BoardVerifyPasswordRequest
 */
export interface BoardVerifyPasswordRequest {
  /**
   * 일련번호
   * @type {number}
   * @memberof BoardVerifyPasswordRequest
   */
  postId?: number | null;
  /**
   * 비밀번호
   * @type {string}
   * @memberof BoardVerifyPasswordRequest
   */
  password?: string | null;
}
/**
 *
 * @export
 * @interface BoardDownloadRequest
 */
export interface BoardDownloadRequest {
  /**
   * path
   * @type {string}
   * @memberof BoardDownloadRequest
   */
  path: string;
}
/**
 *
 * @export
 * @interface ErrorDetail
 */

export interface BoardDownloadModel {
  blobData: Blob;
  contentType: string;
}
export interface ErrorDetail {
  /**
   *
   * @type {string}
   * @memberof ErrorDetail
   */
  key?: string | null;
  /**
   *
   * @type {string}
   * @memberof ErrorDetail
   */
  message?: string | null;
}
/**
 *
 * @export
 * @interface ErrorResponse
 */
export interface ErrorResponse {
  /**
   *
   * @type {string}
   * @memberof ErrorResponse
   */
  code?: string | null;
  /**
   *
   * @type {Array<string>}
   * @memberof ErrorResponse
   */
  messages?: Array<string> | null;
  /**
   *
   * @type {Array<ErrorDetail>}
   * @memberof ErrorResponse
   */
  details?: Array<ErrorDetail> | null;
  /**
   *
   * @type {HttpStatusCode}
   * @memberof ErrorResponse
   */
  status?: HttpStatusCode;
}

/**
 *
 * @export
 * @enum {string}
 */

export const HttpStatusCode = {
  Continue: 'Continue',
  SwitchingProtocols: 'SwitchingProtocols',
  Processing: 'Processing',
  EarlyHints: 'EarlyHints',
  Ok: 'OK',
  Created: 'Created',
  Accepted: 'Accepted',
  NonAuthoritativeInformation: 'NonAuthoritativeInformation',
  NoContent: 'NoContent',
  ResetContent: 'ResetContent',
  PartialContent: 'PartialContent',
  MultiStatus: 'MultiStatus',
  AlreadyReported: 'AlreadyReported',
  ImUsed: 'IMUsed',
  MultipleChoices: 'MultipleChoices',
  MovedPermanently: 'MovedPermanently',
  Found: 'Found',
  SeeOther: 'SeeOther',
  NotModified: 'NotModified',
  UseProxy: 'UseProxy',
  Unused: 'Unused',
  TemporaryRedirect: 'TemporaryRedirect',
  PermanentRedirect: 'PermanentRedirect',
  BadRequest: 'BadRequest',
  Unauthorized: 'Unauthorized',
  PaymentRequired: 'PaymentRequired',
  Forbidden: 'Forbidden',
  NotFound: 'NotFound',
  MethodNotAllowed: 'MethodNotAllowed',
  NotAcceptable: 'NotAcceptable',
  ProxyAuthenticationRequired: 'ProxyAuthenticationRequired',
  RequestTimeout: 'RequestTimeout',
  Conflict: 'Conflict',
  Gone: 'Gone',
  LengthRequired: 'LengthRequired',
  PreconditionFailed: 'PreconditionFailed',
  RequestEntityTooLarge: 'RequestEntityTooLarge',
  RequestUriTooLong: 'RequestUriTooLong',
  UnsupportedMediaType: 'UnsupportedMediaType',
  RequestedRangeNotSatisfiable: 'RequestedRangeNotSatisfiable',
  ExpectationFailed: 'ExpectationFailed',
  MisdirectedRequest: 'MisdirectedRequest',
  UnprocessableEntity: 'UnprocessableEntity',
  Locked: 'Locked',
  FailedDependency: 'FailedDependency',
  UpgradeRequired: 'UpgradeRequired',
  PreconditionRequired: 'PreconditionRequired',
  TooManyRequests: 'TooManyRequests',
  RequestHeaderFieldsTooLarge: 'RequestHeaderFieldsTooLarge',
  UnavailableForLegalReasons: 'UnavailableForLegalReasons',
  InternalServerError: 'InternalServerError',
  NotImplemented: 'NotImplemented',
  BadGateway: 'BadGateway',
  ServiceUnavailable: 'ServiceUnavailable',
  GatewayTimeout: 'GatewayTimeout',
  HttpVersionNotSupported: 'HttpVersionNotSupported',
  VariantAlsoNegotiates: 'VariantAlsoNegotiates',
  InsufficientStorage: 'InsufficientStorage',
  LoopDetected: 'LoopDetected',
  NotExtended: 'NotExtended',
  NetworkAuthenticationRequired: 'NetworkAuthenticationRequired',
} as const;

export type HttpStatusCode = (typeof HttpStatusCode)[keyof typeof HttpStatusCode];

/**
 *
 * @export
 * @interface ProblemDetails
 */
export interface ProblemDetails {
  [key: string]: any;

  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  type?: string | null;
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  title?: string | null;
  /**
   *
   * @type {number}
   * @memberof ProblemDetails
   */
  status?: number | null;
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  detail?: string | null;
  /**
   *
   * @type {string}
   * @memberof ProblemDetails
   */
  instance?: string | null;
}

/**
 * BoardApi - axios parameter creator
 * @export
 */
export const BoardApiAxiosParamCreator = function (configuration?: Configuration) {
  return {
    /**
     *
     * @summary 비자게시글리스트
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {string} [boardType] 게시판구분
     * @param {number} [pageNo] 현재페이지
     * @param {number} [itemCount] 페이지당글개수
     * @param {number} [year] 연도
     * @param {string} [regUserName] 작성자
     * @param {string} [title] 제목
     * @param {string} [content] 내용
     * @param {boolean} [isMobile] 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardGet: async (
      Accept_Language: string,
      boardType?: string,
      pageNo?: number,
      itemCount?: number,
      year?: number,
      regUserName?: string,
      title?: string,
      content?: string,
      isMobile?: boolean,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists('boardGet', 'Accept_Language', Accept_Language);
      const localVarPath = `/Board`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (boardType !== undefined) {
        localVarQueryParameter['boardType'] = boardType;
      }

      if (pageNo !== undefined) {
        localVarQueryParameter['pageNo'] = pageNo;
      }

      if (itemCount !== undefined) {
        localVarQueryParameter['itemCount'] = itemCount;
      }

      if (year !== undefined) {
        localVarQueryParameter['year'] = year;
      }

      if (regUserName !== undefined) {
        localVarQueryParameter['regUserName'] = regUserName;
      }

      if (title !== undefined) {
        localVarQueryParameter['title'] = title;
      }

      if (content !== undefined) {
        localVarQueryParameter['content'] = content;
      }

      if (isMobile !== undefined) {
        localVarQueryParameter['isMobile'] = isMobile;
      }

      if (Accept_Language != null) {
        localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 비자게시글등록
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {BoardInsertRequest} [BoardInsertRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardPost: async (
      Accept_Language: string,
      BoardInsertRequest?: BoardInsertRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists('boardPost', 'Accept_Language', Accept_Language);
      const localVarPath = `/Board`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (Accept_Language != null) {
        localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        BoardInsertRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 비자게시글 상세조회
     * @param {number} postId
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {string} [boardType] 게시판구분
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardPostIdGet: async (
      postId: number,
      Accept_Language: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'postId' is not null or undefined
      assertParamExists('boardPostIdGet', 'postId', postId);
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists('boardPostIdGet', 'Accept_Language', Accept_Language);
      const localVarPath = `/Board/{postId}`.replace(
        `{postId}`,
        encodeURIComponent(String(postId)),
      );
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      if (Accept_Language != null) {
        localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary QNA패스워드확인
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {BoardVerifyPasswordRequest} [BoardVerifyPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardVerifyPasswordPost: async (
      Accept_Language: string,
      BoardVerifyPasswordRequest?: BoardVerifyPasswordRequest,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists('boardVerifyPasswordPost', 'Accept_Language', Accept_Language);
      const localVarPath = `/Board/verify-password`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (Accept_Language != null) {
        localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        BoardVerifyPasswordRequest,
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
    /**
     *
     * @summary 첨부파일 다운로드
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {string} [path]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardDownloadPost: async (
      Accept_Language: string,
      path: string,
      options: RawAxiosRequestConfig = {},
    ): Promise<RequestArgs> => {
      // verify required parameter 'Accept_Language' is not null or undefined
      assertParamExists('boardDownloadPost', 'Accept_Language', Accept_Language);
      const localVarPath = `/Board/download`;
      // use dummy base URL string because the URL constructor only accepts absolute URLs.
      const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
      let baseOptions;
      if (configuration) {
        baseOptions = configuration.baseOptions;
      }

      const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options };
      const localVarHeaderParameter = {} as any;
      const localVarQueryParameter = {} as any;

      localVarHeaderParameter['Content-Type'] = 'application/json';

      if (Accept_Language != null) {
        localVarHeaderParameter['Accept-Language'] = String(Accept_Language);
      }
      setSearchParams(localVarUrlObj, localVarQueryParameter);
      let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
      localVarRequestOptions.headers = {
        ...localVarHeaderParameter,
        ...headersFromBaseOptions,
        ...options.headers,
      };
      localVarRequestOptions.data = serializeDataIfNeeded(
        { path },
        localVarRequestOptions,
        configuration,
      );

      return {
        url: toPathString(localVarUrlObj),
        options: localVarRequestOptions,
      };
    },
  };
};

/**
 * BoardApi - functional programming interface
 * @export
 */
export const BoardApiFp = function (configuration?: Configuration) {
  const localVarAxiosParamCreator = BoardApiAxiosParamCreator(configuration);
  return {
    /**
     *
     * @summary 비자게시글리스트
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {string} [boardType] 게시판구분
     * @param {number} [pageNo] 현재페이지
     * @param {number} [itemCount] 페이지당글개수
     * @param {number} [year] 연도
     * @param {string} [regUserName] 작성자
     * @param {string} [title] 제목
     * @param {string} [content] 내용
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async boardGet(
      Accept_Language: string,
      boardType?: string,
      pageNo?: number,
      itemCount?: number,
      year?: number,
      regUserName?: string,
      title?: string,
      content?: string,
      isMobile?: boolean,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoardListSearchModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.boardGet(
        Accept_Language,
        boardType,
        pageNo,
        itemCount,
        year,
        regUserName,
        title,
        content,
        isMobile,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BoardApi.boardGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary 비자게시글등록
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {BoardInsertRequest} [BoardInsertRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async boardPost(
      Accept_Language: string,
      BoardInsertRequest?: BoardInsertRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoardInsertModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.boardPost(
        Accept_Language,
        BoardInsertRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BoardApi.boardPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary 비자게시글 상세조회
     * @param {number} postId
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async boardPostIdGet(
      postId: number,
      Accept_Language: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<BoardDetailSearchModel>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.boardPostIdGet(
        postId,
        Accept_Language,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BoardApi.boardPostIdGet']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary QNA패스워드확인
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {BoardVerifyPasswordRequest} [BoardVerifyPasswordRequest]
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async boardVerifyPasswordPost(
      Accept_Language: string,
      BoardVerifyPasswordRequest?: BoardVerifyPasswordRequest,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<boolean>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.boardVerifyPasswordPost(
        Accept_Language,
        BoardVerifyPasswordRequest,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BoardApi.boardVerifyPasswordPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
    /**
     *
     * @summary 첨부파일 다운로드
     * @param {string} Accept_Language Culture code (예: en-US, ko-KR)
     * @param {string} path
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    async boardDownloadPost(
      Accept_Language: string,
      path: string,
      options?: RawAxiosRequestConfig,
    ): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<string>> {
      const localVarAxiosArgs = await localVarAxiosParamCreator.boardDownloadPost(
        Accept_Language,
        path,
        options,
      );
      const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
      const localVarOperationServerBasePath =
        operationServerMap['BoardApi.boardDownloadPost']?.[localVarOperationServerIndex]?.url;
      return (axios, basePath) =>
        createRequestFunction(
          localVarAxiosArgs,
          globalAxios,
          BASE_PATH,
          configuration,
        )(axios, localVarOperationServerBasePath || basePath);
    },
  };
};

/**
 * BoardApi - factory interface
 * @export
 */
export const BoardApiFactory = function (
  configuration?: Configuration,
  basePath?: string,
  axios?: AxiosInstance,
) {
  const localVarFp = BoardApiFp(configuration);
  return {
    /**
     *
     * @summary 비자게시글리스트
     * @param {BoardApiBoardGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardGet(
      requestParameters: BoardApiBoardGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<BoardListSearchModel> {
      return localVarFp
        .boardGet(
          requestParameters.Accept_Language,
          requestParameters.boardType,
          requestParameters.pageNo,
          requestParameters.itemCount,
          requestParameters.year,
          requestParameters.regUserName,
          requestParameters.title,
          requestParameters.content,
          requestParameters.isMobile,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 비자게시글등록
     * @param {BoardApiBoardPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardPost(
      requestParameters: BoardApiBoardPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<BoardInsertModel> {
      return localVarFp
        .boardPost(requestParameters.Accept_Language, requestParameters.BoardInsertRequest, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 비자게시글 상세조회
     * @param {BoardApiBoardPostIdGetRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardPostIdGet(
      requestParameters: BoardApiBoardPostIdGetRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<BoardDetailSearchModel> {
      return localVarFp
        .boardPostIdGet(requestParameters.postId, requestParameters.Accept_Language, options)
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary QNA패스워드확인
     * @param {BoardApiBoardVerifyPasswordPostRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardVerifyPasswordPost(
      requestParameters: BoardApiBoardVerifyPasswordPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<boolean> {
      return localVarFp
        .boardVerifyPasswordPost(
          requestParameters.Accept_Language,
          requestParameters.BoardVerifyPasswordRequest,
          options,
        )
        .then((request) => request(axios, basePath));
    },
    /**
     *
     * @summary 첨부파일 다운로드
     * @param {BoardDownloadRequest} requestParameters Request parameters.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     */
    boardDownloadPost(
      requestParameters: BoardApiBoardDownloadPostRequest,
      options?: RawAxiosRequestConfig,
    ): AxiosPromise<string> {
      return localVarFp
        .boardDownloadPost(requestParameters.Accept_Language, requestParameters.path, options)
        .then((request) => request(axios, basePath));
    },
  };
};

/**
 * Request parameters for boardGet operation in BoardApi.
 * @export
 * @interface BoardApiBoardGetRequest
 */
export interface BoardApiBoardGetRequest {
  /**
   * Culture code (예: en-US, ko-KR)
   * @type {string}
   * @memberof BoardApiBoardGet
   */
  readonly Accept_Language: string;

  /**
   * 게시판구분
   * @type {string}
   * @memberof BoardApiBoardGet
   */
  readonly boardType?: string;

  /**
   * 현재페이지
   * @type {number}
   * @memberof BoardApiBoardGet
   */
  readonly pageNo?: number;

  /**
   * 페이지당글개수
   * @type {number}
   * @memberof BoardApiBoardGet
   */
  readonly itemCount?: number;

  /**
   * 연도
   * @type {number}
   * @memberof BoardApiBoardGet
   */
  readonly year?: number;

  /**
   * 작성자
   * @type {string}
   * @memberof BoardApiBoardGet
   */
  readonly regUserName?: string;

  /**
   * 제목
   * @type {string}
   * @memberof BoardApiBoardGet
   */
  readonly title?: string;

  /**
   * 내용
   * @type {string}
   * @memberof BoardApiBoardGet
   */
  readonly content?: string;

  /**
   * 모바일 여부
   * @type {boolean}
   * @memberof BoardApiBoardGet
   */
  readonly isMobile?: boolean;
}

/**
 * Request parameters for boardPost operation in BoardApi.
 * @export
 * @interface BoardApiBoardPostRequest
 */
export interface BoardApiBoardPostRequest {
  /**
   * Culture code (예: en-US, ko-KR)
   * @type {string}
   * @memberof BoardApiBoardPost
   */
  readonly Accept_Language: string;

  /**
   *
   * @type {BoardInsertRequest}
   * @memberof BoardApiBoardPost
   */
  readonly BoardInsertRequest?: BoardInsertRequest;
}

/**
 * Request parameters for boardPostIdGet operation in BoardApi.
 * @export
 * @interface BoardApiBoardPostIdGetRequest
 */
export interface BoardApiBoardPostIdGetRequest {
  /**
   *
   * @type {number}
   * @memberof BoardApiBoardPostIdGet
   */
  readonly postId: number;

  /**
   * Culture code (예: en-US, ko-KR)
   * @type {string}
   * @memberof BoardApiBoardPostIdGet
   */
  readonly Accept_Language: string;
}

/**
 * Request parameters for boardVerifyPasswordPost operation in BoardApi.
 * @export
 * @interface BoardApiBoardVerifyPasswordPostRequest
 */
export interface BoardApiBoardVerifyPasswordPostRequest {
  /**
   * Culture code (예: en-US, ko-KR)
   * @type {string}
   * @memberof BoardApiBoardVerifyPasswordPost
   */
  readonly Accept_Language: string;

  /**
   *
   * @type {BoardVerifyPasswordRequest}
   * @memberof BoardApiBoardVerifyPasswordPost
   */
  readonly BoardVerifyPasswordRequest?: BoardVerifyPasswordRequest;
}

/**
 * Request parameters for boardDownloadPost operation in BoardApi.
 * @export
 * @interface BoardApiBoardDownloadPostRequest
 */
export interface BoardApiBoardDownloadPostRequest {
  /**
   * Culture code (예: en-US, ko-KR)
   * @type {string}
   * @memberof BoardApiBoardDownloadPost
   */
  readonly Accept_Language: string;

  /**
   *
   * @type {path}
   * @memberof BoardApiBoardDownloadPost
   */
  readonly path: string;
}

/**
 * BoardApi - object-oriented interface
 * @export
 * @class BoardApi
 * @extends {BaseAPI}
 */
export class BoardApi extends BaseAPI {
  /**
   *
   * @summary 비자게시글리스트
   * @param {BoardApiBoardGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoardApi
   */
  public boardGet(requestParameters: BoardApiBoardGetRequest, options?: RawAxiosRequestConfig) {
    return BoardApiFp(this.configuration)
      .boardGet(
        requestParameters.Accept_Language,
        requestParameters.boardType,
        requestParameters.pageNo,
        requestParameters.itemCount,
        requestParameters.year,
        requestParameters.regUserName,
        requestParameters.title,
        requestParameters.content,
        requestParameters.isMobile,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 비자게시글등록
   * @param {BoardApiBoardPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoardApi
   */
  public boardPost(requestParameters: BoardApiBoardPostRequest, options?: RawAxiosRequestConfig) {
    return BoardApiFp(this.configuration)
      .boardPost(requestParameters.Accept_Language, requestParameters.BoardInsertRequest, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 비자게시글 상세조회
   * @param {BoardApiBoardPostIdGetRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoardApi
   */
  public boardPostIdGet(
    requestParameters: BoardApiBoardPostIdGetRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BoardApiFp(this.configuration)
      .boardPostIdGet(requestParameters.postId, requestParameters.Accept_Language, options)
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary QNA패스워드확인
   * @param {BoardApiBoardVerifyPasswordPostRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoardApi
   */
  public boardVerifyPasswordPost(
    requestParameters: BoardApiBoardVerifyPasswordPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BoardApiFp(this.configuration)
      .boardVerifyPasswordPost(
        requestParameters.Accept_Language,
        requestParameters.BoardVerifyPasswordRequest,
        options,
      )
      .then((request) => request(this.axios, this.basePath));
  }

  /**
   *
   * @summary 첨부파일 다운로드
   * @param {BoardDownloadRequest} requestParameters Request parameters.
   * @param {*} [options] Override http request option.
   * @throws {RequiredError}
   * @memberof BoardApi
   */
  public boardDownloadPost(
    requestParameters: BoardApiBoardDownloadPostRequest,
    options?: RawAxiosRequestConfig,
  ) {
    return BoardApiFp(this.configuration)
      .boardDownloadPost(requestParameters.Accept_Language, requestParameters.path, options)
      .then((request) => request(this.axios, this.basePath));
  }
}
